<template>
  <div>
    <div class="container two-col-panel">
      <!-- Left panel: Date, Foreman, AIA Sen Tech -->
      <div class="left-panel">
        <h2>Yearly PPM Details</h2>
        <div class="field-row">
          <span class="tag"><strong>Select Date:</strong></span>
          <el-date-picker
            v-model="date"
            type="date"
            style="width:200px"
            placeholder="Select Date"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            size="mini"
          ></el-date-picker>
        </div>
        <div class="field-row">
          <span class="tag"><strong>Select Foreman:</strong></span>
          <el-select
            v-model="foreman"
            filterable
            style="width:200px"
            remote
            size="mini"
            @change="clearSearch"
            clearable
            placeholder="Select Foreman"
            :remote-method="foremanMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableForemen"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="field-row">
          <span class="tag"><strong>Select AIA Sen. Tech:</strong></span>
          <el-select
            v-model="senTech"
            filterable
            style="width:200px"
            remote
            size="mini"
            @change="clearSearch"
            clearable
            placeholder="Select AIA Sen. Tech"
            :remote-method="senTechMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableSenTechs"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <!-- Right panel: Component Filters -->
      <div class="right-panel">
        <h2>Select Components</h2>
        <div class="filter-row">
          <div class="filter-cell">
            <span class="tag"><strong>Hall</strong></span>
            <el-select v-model="filterHall" placeholder="Hall" size="mini" clearable style="width:100%" @change="onFilterHall">
              <el-option v-for="item in halls" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="filter-cell">
            <span class="tag"><strong>System</strong></span>
            <el-select v-model="filterSystem" placeholder="System" size="mini" clearable style="width:100%" @change="onFilterSystem">
              <el-option v-for="item in availableSystems" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="filter-cell">
            <span class="tag"><strong>Group</strong></span>
            <el-select v-model="filterGroup" placeholder="Group" size="mini" clearable style="width:100%" @change="onFilterGroup">
              <el-option v-for="item in availableGroups" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-row" style="margin-bottom:8px;">
          <div class="filter-cell">
            <span class="tag"><strong>Code</strong></span>
            <el-select v-model="filterCode" placeholder="Code" size="mini" clearable style="width:100%" @change="onFilterCode">
              <el-option v-for="item in availableCodes" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
          <div class="filter-cell filter-cell--wide">
            <span class="tag"><strong>Description</strong></span>
            <el-select v-model="filterDescription" placeholder="Description" size="mini" clearable style="width:100%" @change="onFilterDescription">
              <el-option v-for="item in availableDescriptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="selectedComponents.length > 0" style="margin-top:8px;">
          <span class="tag"><strong>Selected ({{ selectedComponents.length }}):</strong></span>
          <el-tag v-for="comp in selectedComponents" :key="comp.id" size="mini" style="margin:2px;">{{ comp.literal }}</el-tag>
        </div>
      </div>
    </div>

    <el-row class="container">
      <el-row>
        <h2>Personnel Involved</h2>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="tag">
            <strong>Tech Name</strong>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tag">
            <strong>Date</strong>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tag">
            <strong>Time Started</strong>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="tag">
            <strong>Time Ended</strong>
          </div>
        </el-col>
      </el-row>
      <template v-for="(p, index) in techs">
        <el-row :key="index" v-if="p.id">
          <el-col :span="6">
            <el-select
              v-model="p.id"
              filterable
              :style="{ width: '220px' }"
              remote
              size="mini"
              @change="techUpdate(p.id, index)"
              clearable
              placeholder="Add Technician"
              :remote-method="foremanMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in availableForemen"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-date-picker
              v-model="p.date"
              type="date"
              placeholder="Date"
              size="mini"
              format="dd/MM/yyyy"
              :style="{ width: '150px' }"
            ></el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-input
              placeholder="00:00"
              v-on:input="startTimeChange(index)"
              v-model="p.start"
              size="mini"
              maxlength="5"
              :style="{ width: '150px' }"
            ></el-input>
          </el-col>
          <el-col :span="6">
            <el-input
              placeholder="00:00"
              v-on:input="endTimeChange(index)"
              v-model="p.end"
              size="mini"
              maxlength="5"
              :style="{ width: '150px' }"
            ></el-input>
          </el-col>
        </el-row>
      </template>
      <el-row>
        <el-col :span="6">
          <el-select
            v-model="selectedTech"
            filterable
            @change="pushPersonnel"
            :style="{ width: '220px' }"
            remote
            size="mini"
            clearable
            placeholder="Add Technician"
            :remote-method="foremanMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableForemen"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-row>

    <br />

    <el-row class="container">
      <el-row>
        <h2>Remarks</h2>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6" align="left">
          <div class="tag">
            <strong>Remarks</strong>
          </div>
        </el-col>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Proposed Actions</strong>
          </div>
        </el-col>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Work Order ID</strong>
          </div>
        </el-col>
        <el-col :span="10" align="left">
          <div class="tag">
            <strong>Description</strong>
          </div>
        </el-col>
      </el-row>
      <el-row v-for="(remark, index) in remarksList" :key="index" :gutter="10">
        <el-col :span="6" align="left">
          <el-input
            type="textarea"
            v-model="remark.text"
            placeholder="Enter your remarks here"
            :rows="1"
            :style="{ width: 'calc(100% - 10px)', marginRight: '5px' }"
            @change="addRemarkLine(index)"
          ></el-input>
        </el-col>
        <el-col :span="4" align="left">
          <el-select
            v-model="remark.action"
            placeholder="Select Action"
            size="mini"
            clearable
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="action in proposed_action"
              :key="action"
              :label="action"
              :value="action"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" align="left">
          <el-select
            v-model="remark.workOrderId"
            filterable
            :style="{ width: '100%' }"
            remote
            size="mini"
            @change="WOUpdate(remark.workOrderId, index)"
            clearable
            placeholder="Add Work Order"
            :remote-method="workOrderMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in availableWorkOrders"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="10" align="left">
          <p
            v-if="remark.workOrderId"
            style="text-align: left; margin-top: 5px; padding: 5px; border: 1px solid rgb(0, 0, 0); width: 150%;"
          >
            {{ getWorkOrderDescription(remark.workOrderId) }}
          </p>
        </el-col>
      </el-row>
    </el-row>

    <br />

    <el-row class="container">
      <el-row>
        <h2>Status</h2>
      </el-row>

      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Maintenance Shift:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-select
            v-model="shift"
            placeholder="Select Shift"
            size="mini"
            :style="{ width: '200px' }"
            clearable
          >
            <el-option
              v-for="item in shiftOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Select Status:</strong>
          </div>
        </el-col>
        <el-col :span="20" align="left">
          <el-select
            v-model="status"
            placeholder="Status"
            size="mini"
            :style="{ width: '200px' }"
            clearable
          >
            <el-option
              v-for="item in statuses"
              :key="item.id"
              :label="item.literal"
              :value="item.literal"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row v-if="status !== 'Pending'">
        <el-col :span="4" align="left">
          <div class="tag">
            <strong>Completion Date</strong>
          </div>
        </el-col>
        <el-col :span="12">
          <el-date-picker
            v-model="completionDate"
            type="date"
            placeholder="Completion Date"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            size="mini"
            :style="{ width: '200px' }"
          ></el-date-picker>
        </el-col>
      </el-row>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-button type="success" @click="submitPPMyearly">Submit</el-button>
    </el-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { personnel } from "../../api/personnel/personnel";
import { aiaPersonnel } from "../../api/personnel/aiaPersonnel";
import PersonnelSelector from "../Selectors/PersonnelSelector.vue";
import StatusSelector from "../Selectors/StatusSelector.vue";
import { workorder } from "../../api/workorder/workorder";
import { postgrest } from "../../api/postgrest";
import { component } from "../../api/component/component";

export default Vue.extend({
  name: "AddPPMnew",
  components: {
    StatusSelector,
    PersonnelSelector,
  },
  props: {
    isDialog: {
      default: false,
    },
  },
  data() {
    return {
      proposed_action: ["TBM", "TBC", "TBR", "TBF"] as string[],
      halls: [] as string[],
      groups: [] as any[],
      componentList: [] as any[],
      filteredComponents: [] as any[],
      systems: [] as string[],
      availableSystems: [] as string[],
      availableGroups: [] as string[],
      availableCodes: [] as string[],
      availableDescriptions: [] as string[],
      filterHall: "" as string,
      filterSystem: "" as string,
      filterGroup: "" as string,
      filterCode: "" as string,
      filterDescription: "" as string,
      date: "" as any,
      senTechList: [] as any[],
      senTechs: [] as any[],
      availableSenTechs: [] as any[],
      senTech: "" as any,
      loading: false,
      availableForemen: [] as any[],
      personnelList: [] as any[],
      foremen: [] as any[],
      workers: [] as any[],
      foreman: "" as any,
      techs: [] as any[],
      standbyTechs: [] as any[],
      personnel: [] as any[],
      status: "" as any,
      shift: "",
      shiftOptions: [
        { label: "Morning (06:00 - 14:00)", value: "Morning" },
        { label: "Evening (14:00 - 22:00)", value: "Evening" },
        { label: "Night (22:00 - 06:00)", value: "Night" },
      ] as Array<{ label: string; value: string }>,
      completionDate: null as any,
      selectedAction: "" as any,
      remarks: "" as any,
      workOrders: [] as any[],
      availableWorkOrders: [] as any[],
      selectedWorkOrder: "" as any,
      workOrderList: [] as any[],
      selectedComponents: [] as any[],
      workOrderDescription: "",
      selectedTech: "" as any,
      ppm_daily: [] as any[],
      statuses: [] as any[],
      ppm_details: null as any,
      periodicity: "Yearly",
      remarksList: [
        { text: "", action: "", workOrderId: "", description: "" },
      ] as any[],
    };
  },
  async created() {
    await this.getSenTechList();
    await this.getPersonnelList();
    await this.getWorkOrderList();
    await this.getStatuses();
    await this.getComponentList();
  },
  methods: {

    senTechMethod(query: string) {
      if (query !== "" && query !== undefined) {
        this.loading = true;
        this.availableSenTechs = this.senTechs.filter((item) => {
          return (
            item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
            item.team === query
          );
        });
        this.loading = false;
      } else {
        this.availableSenTechs = [];
      }
    },

    foremanMethod(query: string) {
      if (query !== "" && query !== undefined) {
        this.loading = true;
        this.availableForemen = this.foremen
          .filter((item) => {
            return (
              (item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                item.team === query) &&
              this.foreman !== item.value &&
              !this.techs.some((r: any) => r.value === item.value) &&
              !this.standbyTechs.some((r: any) => r.value === item.value)
            );
          })
          .concat(
            this.workers.filter((item) => {
              return (
                (item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                  item.team === query) &&
                this.foreman !== item.value &&
                !this.techs.some((r: any) => r.value === item.value) &&
                !this.standbyTechs.some((r: any) => r.value === item.value)
              );
            })
          );
        this.loading = false;
      } else {
        this.availableForemen = [];
      }
    },

    async submitPPMyearly() {
      const filteredRemarks = this.remarksList.filter(
        (remark: any) =>
          remark.text !== "" ||
          remark.action !== "" ||
          remark.description !== "" ||
          remark.workOrderId !== ""
      );

      if (!this.selectedComponents || this.selectedComponents.length === 0) {
        this.$message.error({
          message: "Please select at least one Code from the filters.",
          showClose: true,
        });
        return;
      }

      const token = this.$store.getters.getToken;
      let successCount = 0;
      let errorCount = 0;

      for (const comp of this.selectedComponents) {
        const ppm_details: any = {
          system: this.mapSystemToId(comp.group2),
          date: this.date,
          foreman: this.foreman,
          sen_tech: this.senTech,
          techs: this.techs,
          remarks: filteredRemarks,
          shift: this.shift || null,
          status: this.status,
          recycled: false,
          periodicity: this.periodicity,
          component: comp.literal,
        };
        if (this.status !== "Pending") {
          ppm_details.completion_date = this.completionDate || null;
        }
        try {
          await postgrest.post("ppm_details", token, ppm_details);
          successCount++;
        } catch (error) {
          errorCount++;
          console.log("Error posting data to PostgREST:", error);
        }
      }

      if (successCount > 0) {
        this.$message.success({
          message: `PPM Yearly Submitted Successfully (${successCount})`,
          showClose: true,
        });
      }
      if (errorCount > 0) {
        this.$message.error({
          message: `Error submitting ${errorCount} PPM(s)`,
          showClose: true,
        });
      }
      if (successCount > 0 && this.$props.isDialog === false) {
        this.$store.dispatch("updateCurrentObject", {});
        this.$store.dispatch("updateCurrentComponent", "PPMList");
        this.$router.replace({ name: "load" });
      }
    },

    mapSystemToId(system: string): number {
      switch (system) {
        case "Conveyors": return 1;
        case "Sorter": return 12;
        case "Inductions": return 5;
        case "Electrical Panels": return 4;
        case "Reclaims": return 3;
        case "Fire Protection": return 6;
        default: return 0;
      }
    },

    async getStatuses() {
      try {
        this.statuses = await postgrest.get(
          "status",
          this.$store.getters.getToken
        );
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    },

    async getComponentList() {
      await component
        .getAllComponents(
          this.$store.getters.getToken,
          this.$store.getters.getHost
        )
        .then((response) => {
          response.json().then((resp) => {
            this.componentList = (JSON.parse(JSON.stringify(resp)) as any[]).filter(
              (r: any) => !r.recycled
            );
            for (const c of this.componentList) {
              if (!this.halls.includes(c.group1)) this.halls.push(c.group1);
              if (!this.systems.includes(c.group2)) this.systems.push(c.group2);
            }
            this.halls.sort();
            this.systems.sort();
            this.filteredComponents = [...this.componentList];
          });
        });
    },

    handleComponentSelection(val: any[]) {
      this.selectedComponents = val;
    },

    removeSelectedComponent(comp: any) {
      const idx = this.selectedComponents.findIndex((c: any) => c.id === comp.id);
      if (idx !== -1) {
        this.selectedComponents.splice(idx, 1);
        if (this.$refs.componentTable) {
          (this.$refs.componentTable as any).toggleRowSelection(comp, false);
        }
      }
    },

    applyFilters() {
      this.filteredComponents = this.componentList.filter(
        (c: any) =>
          (!this.filterHall || c.group1 === this.filterHall) &&
          (!this.filterSystem || c.group2 === this.filterSystem) &&
          (!this.filterGroup || c.group3 === this.filterGroup) &&
          (!this.filterCode || c.group4 === this.filterCode) &&
          (!this.filterDescription || c.group5 === this.filterDescription)
      );
      this.selectedComponents = [...this.filteredComponents];
    },

    onFilterHall() {
      this.filterSystem = "";
      this.filterGroup = "";
      this.filterCode = "";
      this.filterDescription = "";
      this.availableSystems = [];
      this.availableGroups = [];
      this.availableCodes = [];
      this.availableDescriptions = [];
      this.applyFilters();
      if (this.filterHall) {
        for (const c of this.filteredComponents) {
          if (!this.availableSystems.includes(c.group2)) this.availableSystems.push(c.group2);
        }
        this.availableSystems.sort();
      }
    },

    onFilterSystem() {
      this.filterGroup = "";
      this.filterCode = "";
      this.filterDescription = "";
      this.availableGroups = [];
      this.availableCodes = [];
      this.availableDescriptions = [];
      this.applyFilters();
      if (this.filterSystem) {
        for (const c of this.filteredComponents) {
          if (!this.availableGroups.includes(c.group3)) this.availableGroups.push(c.group3);
        }
        this.availableGroups.sort();
      }
    },

    onFilterGroup() {
      this.filterCode = "";
      this.filterDescription = "";
      this.availableCodes = [];
      this.availableDescriptions = [];
      this.applyFilters();
      if (this.filterGroup) {
        for (const c of this.filteredComponents) {
          if (!this.availableCodes.includes(c.group4)) this.availableCodes.push(c.group4);
        }
        this.availableCodes.sort();
      }
    },

    onFilterCode() {
      this.filterDescription = "";
      this.availableDescriptions = [];
      this.applyFilters();
      if (this.filterCode) {
        for (const c of this.filteredComponents) {
          if (!this.availableDescriptions.includes(c.group5)) this.availableDescriptions.push(c.group5);
        }
        this.availableDescriptions.sort();
      }
    },

    onFilterDescription() {
      this.applyFilters();
    },

    async getPersonnelList() {
      await personnel
        .getAllPersonnel(
          this.$store.getters.getToken,
          this.$store.getters.getHost
        )
        .then((response) => {
          response.json().then((resp) => {
            this.personnelList = JSON.parse(JSON.stringify(resp));
            for (const p of this.personnelList) {
              if (this.$store.getters.getUserLevel < 1 || p.active) {
                if (p.wo_specialty === 1) {
                  this.foremen.push({
                    label:
                      p.firstname +
                      " " +
                      p.lastname +
                      (!p.active ? " (INACTIVE)" : ""),
                    value: p.id,
                    team: p.team,
                  });
                } else {
                  this.workers.push({
                    label:
                      p.firstname +
                      " " +
                      p.lastname +
                      (!p.active ? " (INACTIVE)" : ""),
                    value: p.id,
                    team: p.team,
                  });
                }
              }
            }
          });
        });
    },

    async getSenTechList() {
      await aiaPersonnel
        .getAllPersonnel(
          this.$store.getters.getToken,
          this.$store.getters.getHost
        )
        .then((response) => {
          response.json().then((resp) => {
            this.senTechList = JSON.parse(JSON.stringify(resp));
            for (const p of this.senTechList) {
              this.senTechs.push({
                label: p.firstname + " " + p.lastname,
                value: p.id,
                team: p.team,
              });
            }
          });
        });
    },

    async getWorkOrderList() {
      await workorder
        .getSomeWorkOrders(
          this.$store.getters.getToken,
          {},
          this.$store.getters.getHost
        )
        .then((response) => {
          response.json().then((resp: any) => {
            const list = JSON.parse(JSON.stringify(resp));
            for (let i = 0; i <= list.length - 1; i++) {
              this.workOrderList.push({
                value: list[i].aia_id.toString(),
                label: list[i].aia_id.toString(),
                key: list[i].aia_id,
                description: list[i].name,
              });
            }
          });
        });
    },

    pushWorkOrder() {
      if (this.selectedWorkOrder) {
        const selected = this.workOrderList.find(
          (r: any) => r.value === this.selectedWorkOrder
        );
        if (selected) {
          this.workOrders.push({
            id: selected.value,
            description: selected.description,
          });
          this.selectedWorkOrder = "";
        }
      }
    },

    workOrderMethod(query: string) {
      if (query) {
        this.availableWorkOrders = this.workOrderList.filter((item: any) =>
          item.label.toLowerCase().includes(query.toLowerCase())
        );
      } else {
        this.availableWorkOrders = [];
      }
    },
    clearSearch() {
      this.availableForemen = [];
    },
    techUpdate(id: any, index: number) {
      if (id === "") {
        this.techs.splice(index, 1);
      }
    },
    endTimeChange(index: number) {
      if (this.techs[index].end.length === 2) {
        this.techs[index].end += ":";
      }
    },
    startTimeChange(index: number) {
      if (this.techs[index].start.length === 2) {
        this.techs[index].start += ":";
      }
    },
    WOUpdate(id: any, index: number) {
      if (index >= 0 && index < this.remarksList.length) {
        if (id === "") {
          this.remarksList[index].workOrderId = "";
          this.remarksList[index].description = "";
        } else {
          const selected = this.workOrderList.find((r: any) => r.value === id);
          if (selected) {
            this.remarksList[index].workOrderId = selected.value;
            this.remarksList[index].description = selected.description;
          }
        }
      } else {
        console.error("WOUpdate: Invalid index", index);
      }
    },
    addRemarkLine(index: number) {
      if (this.remarksList[index].text !== "") {
        this.remarksList.push({
          text: "",
          action: "",
          workOrderId: "",
          description: "",
        });
      }
    },
    getWorkOrderDescription(id: string) {
      const selected = this.workOrderList.find((r: any) => r.value === id);
      return selected ? selected.description : "";
    },
    pushPersonnel() {
      const selectedPersonnel = this.personnelList.find(
        (r: any) => r.id === this.selectedTech
      );
      if (selectedPersonnel) {
        this.techs.push({
          id: this.selectedTech,
          value: this.selectedTech,
          label: `${selectedPersonnel.firstname} ${selectedPersonnel.lastname}`,
          start: "",
          end: "",
        });
        this.selectedTech = "";
      }
    },
  },
});
</script>

<style scoped>
.two-col-panel {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: flex-start;
}

.left-panel {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.field-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.field-row .tag {
  flex: 0 0 140px;
  text-align: right;
}

.filter-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-end;
  margin-bottom: 8px;
}

.filter-cell {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.filter-cell--wide {
  flex: 2;
}

.container {
  padding: 20px;
  background-color: #e4e2e2;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

h2 {
  color: #333;
  font-weight: 600;
  margin-bottom: 20px;
  border-bottom: 2px solid #409eff;
  padding-bottom: 10px;
}

.tag {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

.el-col {
  display: flex;
  align-items: center;
}

.el-col .el-select,
.el-col .el-date-picker,
.el-col .el-input {
  width: 100%;
}

.el-select .el-input__inner {
  border-radius: 4px;
  border-color: #409eff;
}

.el-date-picker .el-input__inner {
  border-radius: 4px;
  border-color: #409eff;
}

.el-input .el-textarea__inner {
  border-radius: 4px;
  border-color: #409eff;
}

.remarks-tag,
.actions-tag,
.workorder-tag {
  width: 100%;
}

.workorder-tag .tagText {
  margin-bottom: 5px;
}
</style>
